import React from 'react';

import ShowMetrics, { TYPE_METRICS } from '../../helpers/ShowMetrics';

function UserMetrics({ url }: { url: string }) {
    return (
        <div className="row metrics">
            <ShowMetrics
                url={url}
                path="affiliate_earning_from_user"
                label="Earning from user"
                typeMetrics={TYPE_METRICS.VALUE_METRIC}
            />
        </div>
    );
}

export default UserMetrics;
